const AUDITOR_TEAM_TYPE = "Auditor";

// backend joins enum names with ", " (IdentityMicroservice UserProfile)
function isAuditorTeamTypes(teamTypes?: string | null): boolean {
  return (
    teamTypes
      ?.split(",")
      .map((teamType) => teamType.trim())
      .includes(AUDITOR_TEAM_TYPE) ?? false
  );
}

export { isAuditorTeamTypes };
